<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Agendamento | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="nome">Motorista <sup class="text-danger">* </sup></label>
              <a href="#" @click="abrirMotorista(registro.motorista.cd_motorista)">{{ registro.motorista ? registro.motorista.nome : '' }}</a>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select
                v-model="registro.idc_status"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.idc_status }"
              >
                <option value="1">Aguardando Agendamento</option>
                <option value="2">Agendado</option>
                <option value="3">Em Andamento</option>
                <option value="4">Finalizado</option>
                <option value="5">Não Executado</option>
                <option value="9">Cancelado</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cpf">Data Agendada <sup class="text-danger">* </sup></label>
              <vue-pikaday
                class="form-control"
                autocomplete="off"
                style="width: 200px"
                v-model="registro.dt_agendada"
                placeholder="dd/mm/aaaa"
                :options="pikadayOptions"
                v-bind:class="{ 'box-input-required': errors.dt_prevista }"
              />
              <span v-show="errors.dt_agendada != null" class="help-inline">{{ errors.dt_agendada }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cd_ponto_apoio">Ponto de Apoio <sup class="text-danger">* </sup></label>
              <select
                v-model="registro.cd_ponto_apoio"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.cd_ponto_apoio }"
              >
                <option v-for="item in pontos" v-bind:key="item.cd_ponto_apoio" v-bind:value="item.cd_ponto_apoio">
                  {{ item.cd_ponto_apoio }}
                </option>
              </select>
              <span v-show="errors.cd_ponto_apoio != null" class="help-inline">{{ errors.cd_ponto_apoio }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label>
                Horário Agendado <sup class="text-danger">* </sup>
              </label>

              <div>
                <vue-timepicker
                  style="width: 200px;"
                  v-model="registro.hr_agendado"
                  v-bind:class="{ 'box-input-required': errors.hr_agendado }"
                  hide-clear-button
                />
              </div>

              <span
                v-show="errors.hr_agendado != null"
                class="help-inline"
              >
                {{ errors.hr_agendado }}
              </span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import AgendamentoActions from '../../actions/AgendamentoActions'
import PontoApoioActions from '../../actions/PontoApoioActions'
import * as FormInputOptions from './../../helpers/FormInputOptions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      pikadayOptions: FormInputOptions.PikadayOptions,
      errorMessage: '',
      errors: {},
      hasError: false,
      showModalLoader: 0,
      registro: {
        motorista: null,
        idc_status: '',
        dt_agendada: null,
        hr_agendado: {
          HH: null,
          mm: null
        },
        cd_ponto_apoio: ''
      },
      pontos: []
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'
    this.$parent.$parent.$data.showModalLoader = true

    this.showModalLoader++

    AgendamentoActions.obterAgendamento(this.id)
      .then(res => {
        if (res && res.motorista) {
          this.registro = res

          if (this.registro.dt_agendada !== null) {
            this.registro.dt_agendada = moment(this.registro.dt_agendada).toDate()
            this.registro.hr_agendado = {
              HH: String(this.registro.dt_agendada.getHours()).padStart(2, '0'),
              mm: String(this.registro.dt_agendada.getMinutes()).padStart(2, '0')
            }
          }
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }

        this.showModalLoader--
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'

        this.showModalLoader--
      })

    this.showModalLoader++

    PontoApoioActions.listarPontoApoioAtivos()
      .then(res => {
        this.pontos = res

        this.showModalLoader--
      })
      .catch(() => this.showModalLoader--)
  },
  watch: {
    showModalLoader: function (val) {
      if (val === 0) {
        this.$parent.$parent.$data.showModalLoader = false
      }
    }
  },
  methods: {
    voltar () {
      this.$router.push((this.$route.query.ret_url ? this.$route.query.ret_url : '/agendamentos'))
    },
    abrirMotorista (id) {
      this.$router.push(`/motoristas/${id}`)
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.dt_agendada) {
        this.errors.dt_agendada = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.cd_ponto_apoio) {
        this.errors.cd_ponto_apoio = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        this.registro.dt_agendada.setHours(this.registro.hr_agendado.HH)
        this.registro.dt_agendada.setMinutes(this.registro.hr_agendado.mm)

        AgendamentoActions
          .alterarAgendamento({
            id: this.id,
            idc_status: this.registro.idc_status,
            dt_agendada: this.registro.dt_agendada,
            cd_ponto_apoio: this.registro.cd_ponto_apoio
          })
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false
            this.voltar()
          })
          .catch(() => {
            this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            this.$parent.$parent.$data.showModalLoader = false
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/agendamentos/Editar.vue